<template>
  <div class="page-layout">
    <div class="page-content page-content--narrow">
      <AppBreadcrumbs :items="breadcrumbItems" />
      <h1>Новый трек</h1>
      <form class="panel track-form" @submit.prevent>
        <div class="form-field">
          <label for="track-name">Название</label>
          <input
            id="track-name"
            v-model="metadata.name"
            type="text"
            placeholder="Например, утренняя пробежка"
            required
          />
        </div>

        <div class="form-field">
          <label>Описание</label>
          <RichTextEditor
            v-model="metadata.description"
            placeholder="Кратко опишите маршрут"
            :allow-images="false"
          />
        </div>

        <TrackPhotoForm v-model:pending-photos="metadata.pendingPhotos" />

        <TrackDifficultyProfilesForm v-model="metadata.difficulty_profiles" />

        <fieldset class="form-field visibility-field">
          <legend>Видимость</legend>
          <label class="radio-label">
            <input v-model="metadata.public" type="radio" :value="false" />
            Приватный
          </label>
          <label class="radio-label">
            <input v-model="metadata.public" type="radio" :value="true" />
            Публичный
          </label>
        </fieldset>
      </form>

      <GpxUpload :metadata="metadata" @uploaded="onTrackCreated" />
      <TrackRecorder :metadata="metadata" @saved="onTrackCreated" />
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue'
import { useRouter } from 'vue-router'
import AppBreadcrumbs from '../components/AppBreadcrumbs.vue'
import GpxUpload from '../components/GpxUpload.vue'
import RichTextEditor from '../components/RichTextEditor.vue'
import TrackDifficultyProfilesForm from '../components/TrackDifficultyProfilesForm.vue'
import TrackPhotoForm from '../components/TrackPhotoForm.vue'
import TrackRecorder from '../components/TrackRecorder.vue'
import { createDefaultDifficultyProfiles } from '../utils/trackFormat'

const router = useRouter()

const breadcrumbItems = [
  { label: 'Треки', to: { name: 'home' } },
  { label: 'Новый трек' },
]

const metadata = reactive({
  name: '',
  description: '',
  pendingPhotos: [],
  difficulty_profiles: createDefaultDifficultyProfiles(),
  public: false,
})

function onTrackCreated(track) {
  router.push({ name: 'track', params: { id: track.id } })
}
</script>

<style scoped>
.track-form textarea,
.track-form select {
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  padding: 0.625rem 0.75rem;
}

.visibility-field {
  border: none;
  margin: 0;
  padding: 0;
}

.visibility-field legend {
  margin-bottom: 0.375rem;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>
